<template>
  <!--
      作者：gan
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <Head2></Head2>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="审核员"><el-input size="small" v-model="searchForm.remarks_operation"
            placeholder="请输入内容"></el-input></el-form-item>
        <!-- <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="推广账号">
          <el-select size="small" v-model="searchForm.tuiguang_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in tglist" :key="index" :label="item.user_name"
              :value="item.shop_user_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
        <el-form-item><el-button size="small" type="info" @click="getshuax">刷新</el-button></el-form-item>
        <el-form-item>
          <template v-if="dxlist != ''"> <el-button @click="godeleteall()" type="danger" size="small">删除</el-button>
          </template>
          <template v-else> <el-button disabled type="danger" size="small">删除</el-button> </template>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款'" name="payment">
            <span slot="label">未付款 <el-tag size="mini">{{ order_count.payment }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待审核'" name="examine">
            <span slot="label">待审核 <el-tag size="mini">{{ order_count.examine }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待发货'" name="delivery">
            <span slot="label">待发货 <el-tag size="mini">{{ order_count.delivery }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待收货'" name="received">
            <span slot="label">待收货 <el-tag size="mini">{{ order_count.received }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'租赁中'" name="haveInHand">
            <span slot="label">租赁中 <el-tag size="mini">{{ order_count.haveInHand }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待归还'" name="returned">
            <span slot="label">待归还 <el-tag size="mini">{{ order_count.returned }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'归还中'" name="Returning">
            <span slot="label">归还中 <el-tag size="mini">{{ order_count.Returning }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'拒归还'" name="refuse">
            <span slot="label">拒归还 <el-tag size="mini">{{ order_count.refuse }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'取消中'" name="canceling">
            <span slot="label">取消中 <el-tag size="mini">{{ order_count.canceling }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已取消'" name="cancel">
            <span slot="label">已取消 <el-tag size="mini">{{ order_count.cancel }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="complete">
            <span slot="label">已完成 <el-tag size="mini">{{ order_count.complete }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已驳回'" name="reject">
            <span slot="label">已驳回 <el-tag size="mini">{{ order_count.reject }}</el-tag></span>
          </el-tab-pane>
          <!-- <el-tab-pane label="待评价" name="comment"></el-tab-pane> -->
          <!-- <el-tab-pane :label="'已买断'" name="BuyOut">
                <span slot="label">已买断 <el-tag size="mini">{{order_count.BuyOut}}</el-tag></span>
              </el-tab-pane> -->
        </el-tabs>
        <!-- <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
          v-loading="loading" @selection-change="handleSelectionChange"> -->
        <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading" :max-height="500"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" style="min-width: 100px;">
          </el-table-column>
          <el-table-column label="ID" width="60">
            <template slot-scope="scope">
              <div class="gray9" style="height:500px;display:flex;align-items: center;"> {{ scope.row.order_id }}</div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div style="display:flex;justify-content:center;align-items:center;">
                <img style="width: 65px;height: 65px;" :src="scope.row.product[0].image.file_path">
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="user_id" label="订单信息" width="290">
            <template slot-scope="scope">
              <div style="display:flex;align-items: center;">
                <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                  <div class="disf">
                    <div v-if="item.product_attr.indexOf('不') != -1 && item.product_attr.indexOf('保障服务')">
                    </div>
                    <div v-else>
                      <span v-if="item.product_attr.indexOf('保障服务') != -1" class="bzfw">已投碎屏险保障</span>
                    </div>
                    <div class="c_main">订单号：{{ scope.row.order_no }}</div>
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }} </div>

                    <div class="leasetype">{{ scope.row.lease_type }} </div>

                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{ item.refund.status.text }}</div>
                    <div>数量: <span class="juz"> x {{ item.total_num }} </span> </div>
                    <div>重复下单: <span style="color:red;"> {{ scope.row.usernum ? scope.row.oldcount : "null" }} 单 </span>
                    </div>
                    <div style="color:red; font-weight: 500;">
                      <span v-html="scope.row.remarks_risk">
                      </span>
                    </div>
                    <div style="color:red; font-weight: 500;">
                      上次风控备注:{{ scope.row.old_beizhu }}
                    </div>
                  </div>
                  <div class="d-c-c d-c">
                    <!-- <div class="orange">￥ {{ item.product_price }}</div> -->
                    <!-- <div class="gray3">x {{ item.total_num }}</div> -->
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="pay_price" label="付款信息" width="180">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <!-- <div class="orange">实付款:{{ scope.row.pay_price }}</div> -->
              <!-- <p class="orange"> 已交总金额：￥ {{ scope.row.yijiao }}</p> -->
              <span style="color: #3498db;">
                总租金:<span class="fontwb">￥{{ scope.row.total_price ? scope.row.total_price : '' }}</span>
              </span>
              <!-- <span class="gray9">(含运费:￥{{ scope.row.express_price }})</span> -->
              <p class=""> 买断价:<span class="fontwb">￥{{ scope.row.new_buy_out_price }}</span></p>
              <p class=""> 优惠:<span class="fontwb">￥{{ scope.row.coupon_money }}</span></p>
              <p class=""> 已还租:<span style="color: #3498db;">￥{{ scope.row.pricezq }}</span></p>
              <p class=""> 预授权+预交租金:<span class="fontwb">￥{{ scope.row.yujyj }}</span></p>
              <div class="">预交租金:<span class="fontwb">￥{{ scope.row.yushou }}</span></div>
              <div class="">预授权押金总额:<span class="fontwb">￥{{ scope.row.ysqyjze }}</span></div>
              <div class="">信用免押:<span style="color: red;">￥0.00</span> </div>
              <!-- <div class="orange">预授权转租金总额:￥{{ scope.row.zhuanzujin }}</div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="yushou" label="预收租金">
                <template slot-scope="scope">
                </template>
              </el-table-column> -->
          <el-table-column prop="" label="买家" width="280">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.user">
              <div class="fwbold">
                <div class="xxflex">
                  租户姓名： <span class="usercolor"> {{ scope.row.username ? scope.row.username : "null" }} </span> /
                  年龄： <span class="usercolor" v-if="scope.row.usernum">{{ scope.row.usernum | getsfz }} </span>
                  <span class="usercolor" v-else> null </span>
                </div>
                <div> 租户昵称：{{ scope.row.user.nickName }}</div>
                <div> 身份证号：{{ scope.row.usernum ? scope.row.usernum : '' }}
                  (<span v-if="scope.row.hasrenzheng == 1">已认证</span>
                  <span v-else style="color:#FF1E10;font-weight: bold;font-size: 14px;">未认证</span>)
                </div>
                <div> 手机号：{{ scope.row.user.mobile ? scope.row.user.mobile : '' }}</div>
                <div> 收货地址:
                  <span>{{ scope.row.address.region.province }}</span>
                  <span>{{ scope.row.address.region.city }}</span>
                  <span>{{ scope.row.address.region.region }}</span>
                  <span>{{ scope.row.address.detail }}</span>
                </div>
                <div>
                  下单IP:{{ scope.row.ip }}
                </div>
                <div>
                  下单地区:{{ scope.row.province }} {{ scope.row.city }} {{ scope.row.district }}
                </div>
                <!-- <div>号码归属地:</div> -->
              </div>
              <div>
                风控分数：<span class="juz"> {{ scope.row.credit_report }} ({{ scope.row.cancel_remark }})</span> <br />
                欺诈分: <span class="juz"> {{ scope.row.ant_shield }} </span>
              </div>
              <div>
                驳回原因: <span class="juz2">{{ scope.row.tips }}</span>
              </div>
              <div>
                取消原因： <span class="juz2"> {{ scope.row.reason ? scope.row.reason : '' }} </span>
              </div>
              <div>
                上次驳回原因: <span class="juz3"> {{ scope.row.usernum ? scope.row.old_desc : "" }} </span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="supplier.name" label="商户名称"></el-table-column> -->

          <el-table-column prop="remarks_operation" label="备注">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div @click="czbztk(scope.row)" style="color:#DD1144;text-align: center;cursor: pointer;">
                {{
                  scope.row.remarks_operation ? scope.row.remarks_operation : "Empty"
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="state_text" label="交易状态" width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div style="display:flex;justify-content: center;align-items: center;">
                <div class="dotg"></div>
                <div style="color: #18bc9c;margin-left: 3px;">
                  {{ scope.row.order_status.value == 40 ? '已驳回' : scope.row.state_text }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="下单时间" width="190">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>下单时间:{{ scope.row.create_time }}</div>
              <div v-if="scope.row.examine_time != 0" style="color:red;">通过时间:{{ scope.row.examine_time | formatDate }}
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="remarks_risk" label="风控备注">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div @click="fzbztk(scope.row)" style="color:#DD1144">{{
                  scope.row.remarks_risk ? scope.row.remarks_risk : "暂无"
                }}</div>
              </template>
            </el-table-column> -->
          <!-- <el-table-column prop="pay_type.text" label="支付方式" width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.value == 20 ? '支付宝支付' : '' }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="delivery_type.text" label="配送方式" width="70">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{ scope.row.user.mobile }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else="">已评价</span>
            </template>
          </el-table-column> -->

          <el-table-column prop="is_comment" label="退款状态" width="110">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>
                <span>{{ scope.row.tuikuanzhauntai }}</span>
                <div v-if="scope.row.tuikuanzhauntai == '失败'">
                  <span> <span class="green">预收错误：</span> {{ scope.row.ys_fail_msg ? scope.row.ys_fail_msg : "无"
                  }}</span>
                  <br>
                  <span> <span class="green">押金错误：</span>{{ scope.row.yj_fail_msg ? scope.row.yj_fail_msg : "无"
                  }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作"> <!-- fixed="right"-->
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="czbutton">
                <div>
                  <el-button v-if="scope.row.order_status.value == 1" size="small" type="primary"
                    @click="showShenhe(scope.row)">通过</el-button>
                </div>
                <div>
                  <el-button
                    v-if="scope.row.state_text == '待审核' || scope.row.state_text == '待发货' || scope.row.state_text == '待收货'"
                    size="small" type="danger" @click="showShenhe2(scope.row)">驳回</el-button>
                  <el-button v-else-if="scope.row.order_status.value == '50'" size="small" type="primary"
                    @click="showShenhe2(scope.row)">同意</el-button>
                </div>
                <div>
                  <el-button @click="gofenpei(scope.row)" type="primary" size="small">分配客户</el-button>
                </div>
                <div>
                  <el-button @click="gofpMerchant(scope.row)" type="warning" size="small">分配商户</el-button>
                </div>
                <!-- <div>
                  <el-button @click="gomayi(scope.row)" type="success" size="small">生成合同</el-button>
                </div> -->
                <div v-if="!scope.row.aiqianhetong">
                  <el-button @click="goaiqian(scope.row)" type="success" size="small">生成合同 </el-button>
                </div>
                <div v-else>
                  <el-button @click="gockaq(scope.row.aiqianhetong)" type="success" size="small">查看合同 </el-button>
                </div>
                <div>
                  <el-button @click="addClick(scope.row)" type="info" size="small"
                    v-auth="'/order/order/detail'">订单详情</el-button>
                </div>
                <div>
                  <el-button @click="submission(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="success"
                    size="small">申请上报</el-button>
                </div>
                <div>
                  <el-button @click="Loan(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="success"
                    size="small">放款报送</el-button>
                </div>
                <div>
                  <el-button @click="goeditsp(scope.row)" type="danger" v-if="scope.row.order_status.text == '待审核'"
                    size="small">修改商品</el-button>
                </div>
                <div>
                  <el-button @click="gozujin(scope.row)" type="primary" size="small">手动扣款</el-button>
                </div>
                <div>
                  <el-button @click="goyujiao(scope.row)" type="primary" size="small">预交租金</el-button>
                </div>

                <div>
                  <el-button v-if="scope.row.delivery_type.value == 10 && scope.row.delivery_status.value == 20"
                    @click="getLogistics(scope.row)" type="primary" size="small">查看物流</el-button>
                </div>
                <div>
                  <el-button v-if="scope.row.delivery_status.value == 10" @click="gofahuo(scope.row)" type="primary"
                    size="small">订单发货</el-button>
                </div>
                <div>
                  <el-button v-if="scope.row.delivery_type.value == 10 && scope.row.delivery_status.value == 20"
                    @click="goque(scope.row)" type="primary" size="small">确定收货</el-button>
                </div>
                <div v-if="scope.row.delivery_type.value == 10 && scope.row.order_status.text == '进行中'">
                  <el-button @click="gotyj(scope.row)" type="danger" size="small">驳回退押金</el-button>
                </div>
                <div>
                  <el-button @click="fxmzcx(scope.row)" type="primary" size="small">风险命中查询</el-button>
                </div>
                <div>
                  <el-button @click="Uploadhzd(scope.row)" type="warning" size="small">上传收货回执单</el-button>
                </div>
                <div>
                  <el-button @click="Uploadpdf(scope.row, '1')" type="danger" size="small">上传代偿证明</el-button>
                </div>
                <div>
                  <el-button @click="Uploadpdf(scope.row, '2')" type="danger" size="small">上传代偿证明书</el-button>
                </div>
                <!-- <div class="anniu">
                <el-button @click="goqianshu(scope.row)" type="success" size="small">查看合同</el-button>
              </div> -->
                <!-- <div>
                <el-button @click="goheton(scope.row)" type="success" size="small">生成合同</el-button>
              </div> -->
                <!-- <div>
                <el-button @click="godelete(scope.row)" type="danger" size="small">删除订单</el-button>
              </div> -->
              </div>
              <el-dropdown split-button type="primary">
                更多菜单
                <el-dropdown-menu slot="dropdown">
                  <div class="anniu1">
                    <el-button @click="kaihu(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="danger"
                      size="small">开户</el-button>
                  </div>
                  <div class="anniu1">
                    <el-button @click="jieqing(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="info"
                      size="small">结清</el-button>
                  </div>
                  <div class="anniu1">
                    <el-button @click="wancheng(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="danger"
                      size="small">完成</el-button>
                  </div>
                  <div class="anniu1">
                    <el-button @click="gohuankuan(scope.row)" type="primary" size="small">三要素</el-button>
                  </div>
                  <div class="anniu1">
                    <el-button @click="gofengkong(scope.row)" type="primary" size="small">风控备注</el-button>
                  </div>
                  <!-- <div>
                        <el-button @click="gocaozuo(scope.row)" type="primary" size="small">操作备注</el-button>
                      </div> -->
                  <!-- <div>
                    <el-button @click="gofenkon(scope.row)" type="primary" size="small">百融风控报告</el-button>
                  </div> -->
                  <div class="anniu1">
                    <el-button @click="gojiedong(scope.row)" type="primary" size="small">资金解冻-预授权</el-button>
                  </div>
                  <div class="anniu1">
                    <el-button @click="goyajin(scope.row)" type="primary" size="small">预授权资金转租金</el-button>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button @click="getLogistics(scope.row)" type="text" size="small">审核</el-button> -->
              <!-- v-if="scope.row.order_status.value == 12" -->
            </template>
          </el-table-column>
        </el-table>
      </div>

       <!--分页-->
       <div class="pagination" style="display: flex;justify-content: center;margin: 0;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" small layout="prev, pager, next" :total="totalDataNumber">
        </el-pagination>
      </div>

      <!-- 上传收货回执单 -->
      <el-dialog title="上传" :visible.sync="dialogVisibleHZD" width="60%">
        <div>
          <el-button @click="chooseImg('schzd', 'schzd')">选择图片</el-button>
          <img class="mt10" v-img-url="schzd" width="200">
          <div style="margin-top: 10px;">
            <el-button @click="qrUploadhzd()">确 定</el-button>
            <el-button @click="dialogVisibleHZD = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 结清弹窗 -->
      <el-dialog title="结清" :visible.sync="dialogVisiblejq" width="60%">
        <div>
          <el-form size="small" ref="jqform" :model="form" label-width="100px">
            <el-form-item label="金额(元)">
              <el-input v-model="jqform.value" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="jqform.type" placeholder="请选择类型">
                <el-option :label="item.type" v-for="(item, index) in jieqingList" :key="index"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-top: 10px;">
            <el-button @click="orderjq()">确 定</el-button>
            <el-button @click="dialogVisiblejq = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 完成弹窗 -->
      <el-dialog title="完成" :visible.sync="dialogVisiblewc" width="60%">
        <div>
          <div style="margin-top: 10px;">
            <div
              style="margin:20px 30px;border-radius: 20px;font-size: 25px;color: red;background-color: #E1E1E1;text-align: center;padding: 15px;">
              是否要进行完成操作!!!
            </div>
            <el-button @click="dialogVisiblewc = false">取 消</el-button>
            <el-button @click="orderwc()">确 定</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 修改商品弹框 -->
      <el-dialog title="修改商品" :visible.sync="dialogVisiblexgsp" width="70%">
        <div style="padding:20px;">
          <div
            style="margin:20px 30px;border-radius: 20px;font-size: 25px;color: red;background-color: #E1E1E1;text-align: center;padding: 15px;">
            如果需要修改订单商品信息，请务必与客户沟通好后进行修改，切记不可私自修改!每次修改都会详细记录!
          </div>

          <div
            style="margin:20px 30px;border-radius: 20px;font-size: 25px;color: #2F96DB;background-color: #E1E1E1;text-align: center;padding: 15px;">
            收货人： {{ shr }} <br>
            电话： {{ shrdh }} <br>
            原商品名称: {{ prData.product_name }} <br>
            原商品规格：{{ prData.product_attr }} <br>
          </div>

          <div style="display:flex;justify-content: center;">
            <div class="mr">
              商品分类：
              <el-select v-model="spflvalue" placeholder="请选择" @change="selectSP($event)">
                <el-option v-for="item in catList" :key="item.category_id" :label="item.name" :value="item.category_id">
                </el-option>
              </el-select>
            </div>
            <div class="mr">
              二级商品分类：
              <el-select v-model="sxspvalue" placeholder="请选择" @change="selectSP2($event)">
                <el-option v-for="(item, index) in catList2" :key="index" :label="item.name" :value="item.category_id">
                </el-option>
              </el-select>
            </div>
            <div class="mr">
              商品名称：
              <el-select v-model="sxggvalue" placeholder="请选择" @change="selectSP3($event)" size="100%">
                <el-option v-for="item in catList3" :key="item.product_id" :label="item.product_name"
                  :value="item.product_id">
                </el-option>
              </el-select>
            </div>

          </div>

          <div style="display:flex;">
            <div class="mr" v-if="catList5.length >= 1">
              {{ catList5[0].group_name }}
              <el-select v-model="Attrvalue" placeholder="请选择" @change="selectSP5($event, catList5[0].group_name, 0)"
                size="100%">
                <el-option v-for="item in catList5[0].spec_items" :key="item.item_id" :label="item.spec_value"
                  :value="item.item_id">
                </el-option>
              </el-select>
            </div>
            <div class="mr" v-if="catList5.length >= 2">
              {{ catList5[1].group_name }}
              <el-select v-model="Attrvalue2" placeholder="请选择" @change="selectSP5($event, catList5[1].group_name, 1)"
                size="100%">
                <el-option v-for="item in catList5[1].spec_items" :key="item.item_id" :label="item.spec_value"
                  :value="item.item_id">
                </el-option>
              </el-select>
            </div>

            <div class="mr" v-if="catList5.length >= 3">
              {{ catList5[2].group_name }}
              <el-select v-model="Attrvalue3" placeholder="请选择" @change="selectSP5($event, catList5[2].group_name, 2)"
                size="100%">
                <el-option v-for="item in catList5[2].spec_items" :key="item.item_id" :label="item.spec_value"
                  :value="item.item_id">
                </el-option>
              </el-select>
            </div>

            <div class="mr" v-if="catList5.length >= 4">
              {{ catList5[3].group_name }}
              <el-select v-model="Attrvalue4" placeholder="请选择" @change="selectSP5($event, catList5[3].group_name, 3)"
                size="100%">
                <el-option v-for="item in catList5[3].spec_items" :key="item.item_id" :label="item.spec_value"
                  :value="item.item_id">
                </el-option>
              </el-select>
            </div>

            <div class="mr" v-if="catList5.length >= 5">
              {{ catList5[4].group_name }}
              <el-select v-model="Attrvalue5" placeholder="请选择" @change="selectSP5($event, catList5[4].group_name, 4)"
                size="100%">
                <el-option v-for="item in catList5[4].spec_items" :key="item.item_id" :label="item.spec_value"
                  :value="item.item_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-top: 10px;">
            <el-button type="primary" @click="xgspqd()">确 定</el-button>
            <el-button @click="dialogVisiblexgsp = false">取 消</el-button>
          </div>

        </div>
      </el-dialog>

      <!-- 订单发货弹窗 -->
      <el-dialog title="物流信息" :visible.sync="dialogVisiblewlfh" width="60%">
        <div>
          <div class="common-form mt16">去发货</div>
          <el-form size="small" ref="form" :model="form" label-width="100px">
            <el-form-item label="物流公司">
              <el-select v-model="form.express_id" placeholder="请选择快递公司">
                <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index"
                  :value="item.express_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model="form.express_no" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="设备编号">
              <el-input v-model="form.equipment_no" class="max-w460"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 10px;">
            <el-button @click="orderqd()">确 定</el-button>
            <el-button @click="dialogVisiblewlfh = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 操作备注弹框 -->
      <el-dialog title="操作备注" :visible.sync="dialogVisiblezcbz" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model.trim="inputzcbz" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px;">
            <el-button @click="zcbzqd()">确 定</el-button>
            <el-button @click="dialogVisiblezcbz = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 审核说明弹框 -->
      <el-dialog title="审核说明" :visible.sync="dialogVisibleshsm" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model="inputshsm" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px;">
            <el-button @click="shsmqd()">确 定</el-button>
            <el-button @click="dialogVisibleshsm = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 风控备注弹框 -->
      <el-dialog title="风控备注" :visible.sync="dialogVisiblefkbz" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model="inputfkbz" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px;">
            <el-button @click="fkbzqd()">确 定</el-button>
            <el-button @click="dialogVisiblefkbz = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 弹窗 -->
      <el-dialog title="三要素" :visible.sync="dialogTableVisible">
        <div style="margin-bottom:10px;"><el-input v-model="sysname" placeholder="请输入姓名"></el-input></div>
        <div style="margin-bottom:10px;"><el-input v-model="syssfz" placeholder="请输入身份证"></el-input></div>
        <div style="margin-bottom:10px;"><el-input v-model="syssjh" placeholder="请输入手机号"></el-input></div>
        <el-button @click="sanyaoshuqd()" type="primary">确 定</el-button>
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div>
            <div class="sanyaosu">姓名，身份证号，手机号{{ sanyaosu }}</div> -->
      </el-dialog>
      <!-- 提交租期 -->
      <el-dialog title="提交租期" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <el-checkbox-group v-model="shneheList">
          <el-checkbox v-for="item in zqlist" :label="item.bill_id" :key="item.bill_id"
            :disabled="item.is_pay_status == 1 ? true : false">{{ '第' + item.current_period + '期' }} {{
              item.repayment_date | formatDate
            }} {{ item.price + '元' }}
          </el-checkbox>
        </el-checkbox-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="queding()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 预交租金 -->
      <el-dialog title="预交租金" :visible.sync="dialogVisible1" width="60%" :before-close="handleClose1">
        <div style="margin:25px 0">
          <el-input v-model="yushou" placeholder="请输入金额"></el-input> <br>
        </div>
        <div style="margin:25px 0">
          <h3 style="margin:20px 0;">碎屏险</h3>

          <el-radio-group v-model="radio">
            <el-radio disabled label="1">已选择</el-radio>
            <el-radio disabled label="2">未选择</el-radio>
          </el-radio-group>
        </div>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="queding1()">确 定</el-button>

      </el-dialog>
      <!-- 风险查询 -->
      <el-dialog title="签署状态" :visible.sync="fengxianchaxun">
        <span class="qianshu">{{ fengxian }}</span>
      </el-dialog>
      <!-- 布尔征信弹窗 -->
      <el-dialog title="布尔征信" :visible.sync="dialogTableVisible1">
        <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div> -->
      </el-dialog>
      <!-- 操作备注 -->
      <el-dialog title="操作备注" :visible.sync="dialogVisible4" width="60%" :before-close="handleClose4">
        <div style="margin:25px 0">
          <el-input v-model="remarksText" placeholder="请输入"></el-input> <br>
        </div>
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="queding4()">确 定</el-button>
      </el-dialog>
      <!-- 风控备注 -->
      <el-dialog title="风控备注" :visible.sync="dialogVisible5" width="60%" :before-close="handleClose5">
        <div style="margin:25px 0">
          <el-input v-model="remarksText1" placeholder="请输入"></el-input> <br>
        </div>
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </el-dialog>
      <!-- 去签署 -->
      <el-dialog title="签署详情" :visible.sync="dialogVisible2" width="60%" :before-close="handleClose2">
        <div style="height:200px">
          <span style="margin:5px;">签署状态：</span>
          <div class="anniu" v-if="folwid">
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '0'" @click="goshowurl()">
              草稿
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '1'" @click="goshowurl()">
              签署中
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '2'" @click="goshowurl()">
              完成
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '3'" @click="goshowurl()">
              撤销
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '5'" @click="goshowurl()">
              过期
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '7'" @click="goshowurl()">
              拒签
            </div>
            <div class="d1" v-if="folwid" @click="xiazai(folwid)">
              点击下载该合同
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 押金转租金 -->
      <el-dialog title="预授权资金转租金" :visible.sync="dialogVisible3" width="60%" :before-close="handleClose3">
        <div style="margin:25px 0">
          <el-input v-model="zujin" placeholder="请输入金额"></el-input> <br>
        </div>
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="queding2()">确 定</el-button>
      </el-dialog>
      <!-- 密码弹窗 -->
      <el-dialog title="请输入密码" :visible.sync="dialogVisible10" width="20%">
        <div style="height:100px;">
          <el-input placeholder="请输入密码" v-model="sdinput" show-password></el-input>
          <div style="margin-top:20px;display: flex;justify-content:center;"><el-button type="primary"
              @click="sdqd()">确定</el-button></div>
        </div>
      </el-dialog>


    </div>
    <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe($event, 'edit')"></Shen>
    <Ju v-if="Ju" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe2($event, 'edit')"></Ju>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog="closeLogistics"> </Logistics>
    <Fenpei v-if="fenpei" :fplist="fplist" :order_id="order_id" @close="closeShenhe3($event, 'edit')"></Fenpei>
    <Merchant v-if="fpsh" :order_id="order_id" @close="closeShenhe4($event, 'edit')"></Merchant>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="config" @returnImgs="returnImgsFunc">
    </Upload>

    <!--上传pdf-->
    <PDF v-if="pdf" :order_id="order_id" :pdftype="pdftype" @close="closeShenhe5($event, 'edit')"></PDF>

  </div>
</template>

<script>
import Head2 from '@/views/layout/Head2.vue';
import axios from 'axios';
import Shen from '../order/order/dialog/shenhe.vue';
import PDF from '../order/order/dialog/uploadPDF.vue';
import Ju from '../order/order/dialog/Ju.vue';
import Fenpei from '../order/order/dialog/fenpei.vue';
import Merchant from '../order/order/dialog//Merchant.vue';
import OrderApi from '@/api/order.js';
import FengkongApi from '@/api/fengkong.js';
import PorductApi from '@/api/product.js';
import Logistics from '@/components/logistics/viewLogistics.vue'
import qs from 'qs';
import { number } from 'echarts/lib/export';
import { indexOf, isArray } from 'zrender/lib/core/util';
import Upload from '@/components/file/Upload';
export default {
  components: {
    Logistics,
    Shen,
    Ju,
    Fenpei,
    Merchant,
    Upload,
    PDF,
    Head2
  },
  data() {
    return {
      pdftype: '',
      config: "",
      schzd: "",
      type: [],
      /*是否打开图片选择*/
      isupload: false,
      dxlist: "",  //多选删除订单id
      tglist: [],   //推广账号
      shlist: [],   //商户账号
      lease_type: "",
      product_attrdata: "",
      sku_iddata: "",
      // 修改商品数据
      catList: '',
      catList2: '',
      catList3: "",
      catList4: "",
      catList5: [],
      spflvalue: "",
      sxspvalue: "",
      sxggvalue: "",
      spggvalue: "",
      Attrvalue: "",
      Attrvalue2: "",
      Attrvalue3: "",
      Attrvalue4: "",
      Attrvalue5: "",
      ggname: "",
      ggname2: "",
      ggname3: "",
      ggname4: "",
      ggname5: "",
      // 修改商品展示
      shr: "",
      shrdh: "",
      prData: "",
      // 三要素
      sysname: "",
      syssjh: "",
      syssfz: "",
      fengxian: '',
      username: '',
      usernum: '',
      mobile: '',
      /*发货*/
      form: {
        /*订单ID*/
        express_id: 10001,
        /*订单号*/
        express_no: '',
        //设备编号
        equipment_no: ''
      },
      /*快递公司列表*/
      expressList: [],
      /*结清*/
      jqform: {
        /*结清金额*/
        value: '',
        /*结清类型*/
        type: ''
      },
      /*结清类型列表*/
      jieqingList: [{
        type: '正常 (0-30天)',
        value: 1
      },
      {
        type: '关注 (31-60天)',
        value: 2
      },
      {
        type: '次级(61-120天)',
        value: 3
      },
      {
        type: '可疑(121天-180天)',
        value: 4
      },
      {
        type: '损失 (180天以上)',
        value: 5
      }],
      jieguo: "",
      inputshsm: "",
      dialogVisibleshsm: false,
      pdf: false,  //pdf显示弹框
      shenhe: false,
      Ju: false,
      fenpei: false,
      fpsh: false,
      fplist: [],
      inputfkbz: "",
      dialogVisiblefkbz: false,
      inputzcbz: "",
      dialogVisiblezcbz: false,
      sanyaosu: '',
      sanyaosumsg: '',
      dialogTableVisible: false,
      dialogTableVisible1: false,
      fengxianchaxun: false,
      age: "",
      sdinput: "",
      zujin: "",
      shop_url: "",
      htdata: "",
      folwid: '',// 签署id
      radio: "", //碎屏险
      order_id: "",  // order_id 订单id
      remarksText: "",
      remarksText1: "",
      yushou: "",
      /*显示弹框*/
      fengxain1: false,
      dialogVisiblewc: false,
      dialogVisiblejq: false,
      dialogVisiblexgsp: false,
      dialogVisiblewlfh: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible10: false,
      dialogVisibleHZD: false,
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: '',
        order_no: '',
        style_id: '',
        create_time: '',
        tuiguang_id: '',
        remarks_operation: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0
      },
      isLogistics: false,
      logisticsData: {}
    };
  },
  inject: ['baseInfo'],
  created() {
    /*获取列表*/
    this.getData();
    // 获取分类
    this.getFenlei();
    // 获取角色
    this.gofenpei2();

  },
  mounted() {
    window.mobilecheck = this.mobilecheck
  },
  methods: {
    /*上传pdf显示*/
    Uploadpdf(val, type) {
      this.order_id = val.order_id;
      this.pdf = true;
      if (type == '1') {
        this.pdftype = type;
      } else if (type == '2') {
        this.pdftype = type;
      }
    },
    /*选择图片*/
    chooseImg(file_type, file_name) {
      this.file_name = file_name;
      this.isupload = true;
      this.type = file_type;
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null && e.length > 0) {
        if (this.type == 'schzd') {
          this.schzd = e[0].file_path;
        }
      }
    },
    //上传回执单
    Uploadhzd(val) {
      this.schzd = val.wlhz;
      this.dialogVisibleHZD = true;
      this.order_id = val.order_id;
      this.config = { total: 3 }
    },
    //回执单确认
    qrUploadhzd() {
      console.log(this.schzd, this.order_id);
      let data = {
        order_id: this.order_id,
        wlhz: this.schzd,
      }
      OrderApi.upwlhz(data, true)
        .then(res => {
          this.$message({
            type: 'success',
            message: '上传成功'
          });
          this.getData();
          this.dialogVisibleHZD = false;
          this.schzd = '';
        })
        .catch(error => {
        });
    },
    // 多选删除
    godeleteall() {
      this.$confirm('确定要删除选中的订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        // console.log("确定",this.dxlist);
        let data = {
          order_id: this.dxlist,
        }
        OrderApi.deleteall(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    // 多选选中
    handleSelectionChange(val) {
      // console.log(val);
      let dxlist = "";
      for (let dxdata of val) {
        // if (dxdata.order_id != undefined) {
        dxlist += dxdata.order_id + ","
        // }
      }
      // console.log(dxlist);
      this.dxlist = dxlist;
    },
    /* 推广信息*/
    gofenpei2() {
      OrderApi.authuser({
        role_id: 4
      }, true).then(data => {
        this.tglist = data.data.list.data;
      })
    },
    // 刷新订单
    getshuax() {
      this.getData();
      this.$message({
        message: '刷新订单成功',
        type: 'success'
      });
    },
    // 筛选风控手机号
    remarksSj(str) {
      // console.log("筛选风控手机号",str);
      let newStr = str;//返回值
      const phoneReg = /(1[0-9]{2,10})|([0-9]{3,4})?[0-9]{7,8}|[\d\w]+\b@[a-zA-ZA-z0-9]+.[a-z]+/g;//匹配手机号或者固话,邮箱
      const num = str.replace(/\s|[(]|[)]|[(]|[)]|[-]*/g, "");//去除字符串中所有空格、小括号和横杠
      const phone = num.match(phoneReg);//识别手机号或者固话（在字符串内检索指定的值，或找到一个或多个正则表达式的匹配）
      if (isArray(phone)) {
        phone.forEach(mobile => {
          // console.log(mobile)
          var newmobile = '<a onclick="mobilecheck(' + mobile + ')">' + mobile + '</a><br/>'  //现将筛选出来的手机号加上点击事件
          newStr = newStr.replace(mobile, newmobile);  //查找当前手机号 将手机号替换成 有点击事件的手机号
        });

      }
      return newStr;
      // phone && (newStr = phone.join(','));//有值的话得到一个数组，用空格隔开转化为字符串
      // return newStr
    },
    // 点击亲属手机号
    mobilecheck(mobile) {
      let Params = { mobile: mobile };
      OrderApi.searchMobile(Params, true)
        .then(data => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: 'success'
          });
        })
        .catch(error => { });

    },
    // 下载e签宝合同
    xiazai(id) {
      let self = this;
      let flowId = id;
      let Params = { flowid: id };
      OrderApi.xiazai2(Params, true)
        .then(data => {

          window.open(data.data.data.data.files[0].downloadUrl, '_blank');
        })
        .catch(error => { });
    },
    // 关闭弹窗
    closeShenhe(e, f) {
      if (f == 'edit') {
        this.shenhe = e.openDialog;
        this.getData();
      }
    },
    closeShenhe2(e, f) {
      if (f == 'edit') {
        this.Ju = e.openDialog;
        this.getData();
      }
    },
    closeShenhe3(e, f) {
      if (f == 'edit') {
        this.fenpei = e.openDialog;
        this.getData();
      }
    },
    closeShenhe4(e, f) {
      if (f == 'edit') {
        this.fpsh = e.openDialog;
        this.getData();
      }
    },
    // pdf弹框
    closeShenhe5(e, f) {
      if (f == 'edit') {
        this.pdf = e.openDialog;
        this.getData();
      }
    },
    //拒绝
    showShenhe(data) {
      this.order_id = data.order_id;
      this.shenhe = true;
    },
    //提交审核
    showShenhe2(data) {
      this.order_id = data.order_id;
      this.Ju = true;
    },
    //分控备注确定
    fkbzqd() {
      let Params = {
        order_id: this.order_id,
        remarksType: 2,
        remarksText: this.inputfkbz
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          this.dialogVisiblefkbz = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getData();
        })
    },
    // 审核说明确定
    shsmqd() {
      let Params = {
        order_id: this.order_id,
        tuizu: this.inputshsm
      }
      OrderApi.ysunfreeze(Params, true)
        .then(res => {

          this.dialogVisibleshsm = false;
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    //操作备注确定
    zcbzqd() {

      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.inputzcbz
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {

          this.dialogVisiblezcbz = false;
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    // 操作备注弹框
    czbztk(row) {
      this.dialogVisiblezcbz = true;
      this.order_id = row.order_id;
    },

    // 分控备注弹框
    fzbztk(row) {
      this.dialogVisiblefkbz = true;
      this.order_id = row.order_id;
    },
    // 三要素确定
    sanyaoshuqd() {
      console.log(this.sysname, this.syssjh, this.syssfz);
      let Params = {
        usernum: this.syssfz,
        username: this.sysname,
        mobile: this.syssjh
      }
      OrderApi.sanyao(Params, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: res.data.result.resp_msg + "," + "结果:" + res.data.result.resp_data.result_code_desc
            });
          } else {
            this.$message({
              type: 'warning',
              message: res.data.result.resp_msg + "," + "结果:" + res.data.result.resp_data.result_code_desc
            });
          }
          // self.sanyaosumsg = res.data.result.resp_msg;
          // self.sanyaosu = res.data.result.resp_data.result_code_desc;
        })
        .catch(error => { });
    },
    // 三要素
    gohuankuan(row) {
      // console.log(row,"row");
      this.dialogTableVisible = true;
      // let self = this;
      // this.$confirm('确定要查看三要素吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'info '
      // }).then(() => {
      //   let Params = {
      //   usernum:row.user.usernum, 
      //   username:row.user.username, 
      //   mobile:row.user.mobile
      // }
      // OrderApi.sanyao(Params, true)
      //   .then(res => {

      //     self.sanyaosumsg = res.data.result.resp_msg;
      //     self.sanyaosu = res.data.result.resp_data.result_code_desc;
      //   })
      //   .catch(error => { });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消'
      //   });
      // });
    },
    //征信对接
    zhengxin(row) {
      let self = this;
      self.dialogTableVisible1 = true;

      let Params = {
        orderid: row.order_id
      }
      OrderApi.zhengyin(Params, true)
        .then(res => {

          self.sanyaosu = res.data.result

        })
        .catch(error => { });
    },
    handleClick() {
      alert('button click');
    },
    // 资金解冻
    gojiedong(row) {
      this.$confirm('确定要解冻?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        console.log(row.deposit, row.zhuanzujin);
        if (row.deposit > 0) {
          data.tuizu = row.deposit;
        } else {
          data.tuizu = row.zhuanzujin;
        }
        OrderApi.ysunfreeze(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*押金转租金*/
    goyajin(row) {
      this.order_id = row.order_id;
      this.dialogVisible3 = true;
    },
    /*退押金*/
    gotyj(row) {
      this.dialogVisibleshsm = true;
      this.order_id = row.order_id;
    },
    /*删除订单*/
    godelete(row) {
      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.delete(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 确定发货
    orderqd() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error('请选择物流公司');
        return;
      }
      if (param.express_no == '') {
        this.$message.error('请填写物流单号');
        return;
      }
      let order_id = self.order_id;
      OrderApi.delivery({
        param: param,
        order_id: order_id
      },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，发货成功',
            type: 'success'
          });
          self.form.express_no = '';
          self.form.equipment_no = '';
          self.getData();
          self.dialogVisiblewlfh = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 订单确认发货
    gofahuo(row) {
      let self = this;
      self.dialogVisiblewlfh = true;
      const params = row.order_id;
      self.order_id = row.order_id;
      OrderApi.orderdetail({ order_id: params }, true).then(data => {
        self.expressList = data.data.expressList;
      })
        .catch(error => {
        });
    },
    //确定订单
    goque(row) {
      this.$confirm('确定要完成收货该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
          user_id: row.user_id,
        }
        OrderApi.receipt(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '确认成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*风控报告*/
    gofenkon(row) {
      console.log(row, "row");
      this.$confirm('确定生成百融风控报告吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        if (row.risk == '') {
          let data = {
            risk_type: 2,
            user_id: row.user.user_id
          }
          FengkongApi.riskAdd(data, true)
            .then(res => {
              let data1 = {
                risk_type: 1,
                user_id: row.user.user_id
              }
              FengkongApi.riskAdd(data1, true)
                .then(res => {
                  this.$message({
                    type: 'success',
                    message: '生成成功，正在前往~~~'
                  });
                  this.$router.push({
                    path: '/fengkong/operation/detail',
                    query: {
                      uid: row.user.user_id
                    }
                  })
                })
                .catch(error => {
                  self.loading = false;
                });
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          this.$router.push({
            path: '/fengkong/operation/detail',
            query: {
              uid: row.user.user_id
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*签署蚂蚁链代扣*/
    gomayi(row) {
      this.$confirm('确定签署蚂蚁链代扣吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id
        }
        FengkongApi.chuangjianhetong(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '生成成功,请前往订单详情查看~~~'
            });
            // this.$router.push({
            //   path: '/fengkong/operation/detail',
            //   query: {
            //     uid: row.user.user_id
            //   }
            // })
          })
          .catch(error => {
            self.loading = false;
          });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 爱签合同
    goaiqian(row) {
      this.$confirm('确定签署爱签合同吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id
        }
        FengkongApi.createaq(data, true)
          .then(res => {
            if (res.code = 1) {
              this.$message({
                type: 'success',
                message: '生成成功~~~'
              });
            }
          })
          .catch(error => {
            self.loading = false;
            this.$message({
              type: 'info',
              message: '生成失败'
            });
          });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //打开合同
    gockaq(val) {
      window.open(val, '_blank');
    },
    //风险命中查询
    fxmzcx(row) {
      let username = row.username
      let usernum = row.usernum
      let mobile = row.user.mobile
      let fengxian = ''
      this.fengxianchaxun = true;
      axios.post('https://blacklist.jiulove.cn/api.php?key=474e6bb3e64d2e670744ab7fd1ee2e16&phone='
        + mobile + '&idcard=' + usernum + '&realname=' + username, {})
        .then(response => {
          if (response.url == '') {
            fengxian = '暂无命中'
          } else {
            fengxian = '命中'
          }
          this.fengxian = fengxian
          return;
          resolve(response)
        })
        .catch((error) => {
          console.log(error);
          return;
          reject(error);
        })

    },

    /*预交租金确定*/
    queding1() {
      let Params = {
        order_id: this.order_id,
        yushou: this.yushou
      }
      OrderApi.yushou(Params, true)
        .then(res => {
          this.dialogVisible1 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*押金转租金确定*/
    queding2() {
      let Params = {
        order_id: this.order_id,
        money: this.zujin
      }
      OrderApi.zhuanzujin(Params, true)
        .then(res => {
          this.dialogVisible3 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*操作备注弹窗确定*/
    queding4() {
      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.remarksText
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          this.dialogVisible4 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*风控备注弹窗确定*/
    queding5() {
      let self = this;
      let Params = {
        order_id: self.order_id,
        remarksType: 2,
        remarksText: self.remarksText1
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          self.getData();
          self.dialogVisible5 = false;
          self.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*预交租金*/
    goyujiao(row) {
      this.dialogVisible1 = true;
      this.order_id = row.order_id;
      var str = row.product[0].product_attr;
      if (str.indexOf("499") != -1) {
        this.radio = "1";
        console.log("已选择");
      } else {
        this.radio = "2";
        console.log("未选择");
      }
    },
    /*操作备注*/
    gocaozuo(row) {
      this.dialogVisible4 = true;
      this.order_id = row.order_id;
    },
    /*风控备注*/
    gofengkong(row) {
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
    },
    /*提交租期*/
    gozujin(row) {
      this.dialogVisible = true;
      let Params = {
        order_id: row.order_id,
      }
      OrderApi.billinfo(Params, true)
        .then(res => {
          console.log("res", res);
          this.zqlist = res.data.list;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    /*关闭确认*/
    handleClose() {
      this.dialogVisible = false;
    },
    /*关闭确认*/
    handleClose1() {
      this.dialogVisible1 = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
    handleClose5() {
      this.dialogVisible5 = false;
    },
    /*手动扣款弹窗确定*/
    sdqd() {
      console.log(this.sdinput);
      OrderApi.checkpwd({
        password: this.sdinput
      }, true).then(data => {
        console.log(data, "成功");
        if (data.msg == "操作成功") {
          this.dialogVisible10 = false;
          console.log(this.shneheList);
          if (this.shneheList.length <= 0) {
            this.$message({
              message: '请选择归还期数',
              type: 'error'
            });
            return;
          }
          OrderApi.toExamine({
            billid: this.shneheList
          }, true).then(data => {
            this.dialogVisible = false;
            console.log(data, "成功");
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
        } else {
          this.$message.error('操作失败');
        }
      })
    },
    queding() {
      this.dialogVisible10 = true;
    },
    // 申请上报
    submission(row) {
      console.log(row.order_id, "申请上报");
      this.$confirm('确定要申请上报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          orderid: row.order_id,
        }
        OrderApi.testBooleanDemo(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 放款报送
    Loan(row) {
      console.log(row.order_id, "放款报送");
      this.$confirm('确定要放款报送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: row.order_id,
        }
        OrderApi.fkbs(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*签订合同*/
    goheton(row) {
      this.$confirm('确定要生成合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: row.order_id,
        }
        OrderApi.contract(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //开户
    kaihu(row) {
      this.$confirm('确定要继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: this.order_id,
          user_id: this.user_id
        }
        FengkongApi.open(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 结清
    jieqing(row) {
      this.order_id = row.order_id;
      this.dialogVisiblejq = true;
    },
    // 完成
    wancheng(row) {
      console.log(row.order_id);
      this.order_id = row.order_id;
      this.dialogVisiblewc = true;
    },
    // 结清确定
    orderjq() {
      let Params = {
        order_id: this.order_id,
        money: this.jqform.value,
        type: this.jqform.type
      }
      OrderApi.jieqing(Params, true)
        .then(res => {
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
        .catch(error => {
        });
    },
    // 完成确定
    orderwc() {
      this.$confirm('确定要继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: this.order_id
        }
        OrderApi.wancheng(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*去签署*/
    goqianshu(row) {
      this.folwid = row.folwid;
      this.shop_url = row.shop_url;
      if (!row.folwid) {
        this.$message({
          message: '请先操作生成合同',
          type: 'warning'
        });
      } else {
        this.dialogVisible2 = true;
        OrderApi.FlowDetail({
          flowId: row.folwid
        }, true).then(data => {
          this.htdata = data;
          this.getData();
        })
      }
    },
    /*分配客户*/
    gofenpei(row) {
      this.fenpei = true;
      this.order_id = row.order_id;
      console.log(this.order_id, "this");
      OrderApi.authuser({
        role_id: 2
      }, true).then(data => {
        this.fplist = data.data.list.data;
        console.log("data", this.fplist);
      })
    },
    /*分配商户*/
    gofpMerchant(row) {
      this.fpsh = true;
      this.order_id = row.order_id;
      log
    },
    // 跳转合同链接
    goshowurl() {
      open(this.shop_url)
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    // 获取分类
    getFenlei() {
      let self = this;
      PorductApi.catList({}, true)
        .then(data => {
          self.loading = false;
          self.catList = data.data.list;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          // let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let pricezq = 0;
            let item = res.data.list.data[i];
            item.remarks_risk = self.remarksSj(item.remarks_risk); //筛选风控手机号
            if (item.remarks_risk == '') {
              item.remarks_risk = '风控备注：暂无'
            } else {
              item.remarks_risk = '风控备注：<br/> ' + item.remarks_risk
            }
            //退款信息
            if (item.yj_fail_msg == '' && item.ys_fail_msg == '') {
              if (item.order_status.value == '40' || item.order_status.value == '20') {
                item.tuikuanzhauntai = '成功'
              } else {
                item.tuikuanzhauntai = '';
              }

            } else {
              item.tuikuanzhauntai = '失败';
            }

            let shield = item.ant_shield;
            if (shield == '') {
              item.ant_shield = '未生成'
            } else {
              let shield1 = JSON.parse(shield)
              item.ant_shield = shield1.models[0].score
            }
            let ze = item.credit_report
            if (ze == '') {
              item.credit_report = '未生成'
              item.cancel_remark = '未生成'
            } else {
              let ze1 = JSON.parse(ze)
              item.credit_report = ze1.resp_data.score_norm_explain
              item.cancel_remark = ze1.resp_data.verify_recomment
            }
            item.order_bill.forEach(data => {
              if (data.is_pay_status == 1) {
                pricezq = Number(pricezq) + Number(data.price);
              }
            });
            item.pricezq = pricezq.toFixed(2);
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source: item.order_source,
              order_source_text: item.order_source_text,
              is_top_row: true,
              order_status: item.order_status.value,
            };

            if (item.is_yushou != 2) {
              item.yushou = 0;
            }
            var edeposit = item.deposit;
            var zhuanzujinData = item.zhuanzujin;
            var nbop = item.new_buy_out_price;
            if (item.auth_no == '') {
              edeposit = 0;
            }
            if (item.maiduan_no == '') {
              nbop = 0;
            }

            item.yujyj = (Number(item.yushou) + Number(edeposit) + Number(zhuanzujinData)).toFixed(2);
            item.pricezq = pricezq.toFixed(2);
            item.yijiao = (Number(item.yujyj) + Number(pricezq) + Number(zhuanzujinData) + Number(nbop)).toFixed(2);
            item.ysqyjze = (Number(zhuanzujinData) + Number(edeposit)).toFixed(2);
            item.total_price = (Number(item.total_price) - Number(item.deposit) - Number(zhuanzujinData)).toFixed(2);

            let strdata = item.product[0].product_attr;
            // console.log(strdata.indexOf("租完即送"));
            if (strdata.indexOf("租完即送") != -1) {
              item.lease_type = '租完即送';
            } else {
              item.lease_type = '租完买断';
            }

            // if (item.lease_type == 1) {
            //   item.lease_type = '租完即送';
            // } else if (item.lease_type == 2) {
            //   item.lease_type = '租完买断';
            // }

            // list.push(topitem);
            // list.push(item);
          }
          // self.tableData.data = list;
          self.tableData = res.data.list;
          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },

    // 修改商品
    goeditsp(row) {
      this.dialogVisiblexgsp = true;
      console.log(row);
      this.order_id = row.order_id;
      this.shrdh = row.user.mobile;
      this.shr = row.user.username;
      this.prData = row.product[0];
    },

    selectSP(e) {
      // console.log(e);
      this.spflvalue = e;
      console.log("spflvalue", this.spflvalue);
      for (let var1 of this.catList) {
        if (var1.category_id == e) {
          // console.log(var1);
          this.catList2 = var1.child;
        }
      }
    },

    selectSP2(e) {
      // console.log(e);
      this.sxspvalue = e;
      console.log("sxspvalue", this.sxspvalue);
      let self = this;
      PorductApi.productList({
        category_id: e,
        page: 1,
        list_rows: 10
      }, true)
        .then(data => {
          self.loading = false;
          self.catList3 = data.data.list.data;
        })
        .catch(error => {
          self.loading = false;
        });

    },

    selectSP3(e) {
      // console.log(e);
      this.sxggvalue = e;
      console.log("sxggvalue", this.sxggvalue);
      let self = this;
      PorductApi.getEditData({
        product_id: e,
      },
        true
      )
        .then(res => {
          // console.log(res,"kkkk");
          this.catList4 = res.data.model.sku;
          this.catList5 = res.data.specData.spec_attr;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    selectSP4(e) {
      // console.log(e);
      this.spggvalue = e;
      console.log("spggvalue", this.spggvalue);
    },

    selectSP5(e, name, index) {
      if (name == '套餐') {
        this.catList5[index].spec_items.forEach(element => {
          if (element.item_id == e) {
            if (element.spec_value == '租完买断') {
              this.lease_type = 2
            } else if (element.spec_value == '租完即送') {
              this.lease_type = 1
            } else {
              this.$message({
                showClose: true,
                message: '暂无该套餐',
                type: 'error'
              });
            }
          }
        });
      }

      // console.log(e);
      switch (index) {
        case 0:
          this.Attrvalue = e;
          this.ggname = name;
          // console.log("值：", this.Attrvalue,name,index);
          this.sku_iddata = this.Attrvalue;
          break;
        case 1:
          this.Attrvalue2 = e;
          this.ggname2 = name;
          // console.log("值：", this.Attrvalue1,name,index);
          this.sku_iddata = this.Attrvalue + "_" + this.Attrvalue2;
          break;
        case 2:
          this.Attrvalue3 = e;
          this.ggname3 = name;
          // console.log("值：", this.Attrvalue2,name,index);
          this.sku_iddata = this.Attrvalue + "_" + this.Attrvalue2 + "_" + this.Attrvalue3;
          console.log(2, e);
          break;
        case 3:
          this.Attrvalue4 = e;
          this.ggname4 = name;
          // console.log("值：", this.Attrvalue3,name,index);
          console.log(3, e);
          this.sku_iddata = this.Attrvalue + "_" + this.Attrvalue2 + "_" + this.Attrvalue3 + "_" + this.Attrvalue4;
          break;
        case 4:
          this.Attrvalue5 = e;
          this.ggname5 = name;
          // console.log("值：", this.Attrvalue4,name,index);
          this.sku_iddata = this.Attrvalue + "_" + this.Attrvalue2 + "_" + this.Attrvalue3 + "_" + this.Attrvalue4 + "_" + this.Attrvalue5;
          // console.log("sku_id:",this.Attrvalue + "_" +this.Attrvalue2 + "_" +this.Attrvalue3 + "_" +this.Attrvalue4 + "_" +this.Attrvalue5);
          break;

      }


      for (let data of this.catList5) {
        for (let item of data.spec_items) {
          if (item.item_id == this.Attrvalue) {
            // console.log("spec_value",item.spec_value);
            var ncval = item.spec_value;
            this.product_attrdata = this.ggname + ":" + ncval + ";"
          }
          if (item.item_id == this.Attrvalue2) {
            // console.log("spec_value",item.spec_value);
            var ysval = item.spec_value;
            this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
          }
          if (item.item_id == this.Attrvalue3) {
            // console.log("spec_value",item.spec_value);
            var csval = item.spec_value;
            this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
              + this.ggname3 + ":" + csval + ";"
          }
          if (item.item_id == this.Attrvalue4) {
            // console.log("spec_value",item.spec_value);
            var tcval = item.spec_value;
            this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
              + this.ggname3 + ":" + csval + ";" + this.ggname4 + ":" + tcval + ";"
          }
          if (item.item_id == this.Attrvalue5) {
            // console.log("spec_value",item.spec_value);
            var bzval = item.spec_value;
            this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
              + this.ggname3 + ":" + csval + ";" + this.ggname4 + ":" + tcval + ";" + this.ggname5 + ":" + bzval + ";"
          }
          // console.log("product_attr:",this.ggname+":"+ncval +";" + this.ggname2+":"+ysval+";"
          //    +this.ggname3+":"+csval+";" + this.ggname4+":"+tcval+";" +this.ggname5+":"+bzval+";");
          // this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
          //     + this.ggname3 + ":" + csval + ";" + this.ggname4 + ":" + tcval + ";" + this.ggname5 + ":" + bzval + ";"
        }
      }

    },

    // 修改商品确定
    xgspqd() {
      let self = this;
      OrderApi.checkproduct({
        order_id: self.order_id,
        product_id: self.sxggvalue,
        sku_id: self.sku_iddata,
        product_attr: self.product_attrdata,
        lease_type: self.lease_type
      }, true)
        .then(data => {
          // location.reload();
          self.order_id = "";
          self.sxggvalue = "";
          self.sku_iddata = "";
          self.product_attrdata = "";
          self.lease_type = "";
          self.dialogVisiblexgsp = false;
          self.getData();
          self.$message({
            message: '操作成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
      window.open(routeData.href, '_blank');
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      }
      self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          self.openLogistics()
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    }
  },
  filters: {
    // 过滤器
    formatDate(value) {
      let date = new Date(value * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    },
    // 身份证换算成年龄
    getsfz(iden) {
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;

        if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

        if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
      }
      return age
      // this.age = age;

    }
  },
};
</script>
<style lang="scss">

  .dotg {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #18bc9c;
}

.bzfw {
  color: #3722c2;
  background: #ddd8ff;
  font-size: 12px;
  padding: 2px 10px;
}

.leasetype {
  background-color: #A894A6;
  color: white;
  padding: 2px 10px;
  width: 70px;
  text-align: center;
}

.fontwb {
  font-weight: bold;
}

.mr {
  margin: 20px 30px;
}

.fwbold {
  font-weight: bold;
  font-size: 13px;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #FFA49F;
  padding: 5px;
  background-color: #FFF1F0;
  color: #F6363E;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.czbutton div {
  margin-bottom: 3px;
}

.anniu1 {
  margin-bottom: 3px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.disf {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.xiegang {
  color: #18BC9C;
  margin: 0 5px;
}

.xxflex {
  display: flex;
}

.usercolor {

  color: #3498db;
  font-weight: bold;
}

.juz {
  white-space: normal;
  color: #3498db;
}

.juz2 {
  white-space: normal;
  color: #E74C3C;
}

.juz3 {
  white-space: normal;
  color: #f39c12;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.sanyaosu {
  text-align: center;
  font-size: 20px;
  margin: 10px;
}

.qianshu {
  font-size: 20px;
  color: red;
}



</style>



// WEBPACK FOOTER //
// src/views/layout/phone.vue